import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=c4349582&scoped=true&"
import script from "./TimelineItem.vue?vue&type=script&lang=js&"
export * from "./TimelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4349582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {VBtn,VCol,VDivider,VRow,VTimelineItem})
